var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBody = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.345 6.029a.426.426 0 0 1 .25.554l-4.374 11.142a.44.44 0 0 1-.565.246.426.426 0 0 1-.252-.553L13.78 6.274a.44.44 0 0 1 .566-.246ZM8.372 8.697c.17.167.17.439 0 .606l-2.316 2.268 2.316 2.269c.17.167.17.438 0 .606a.444.444 0 0 1-.619 0l-2.625-2.572a.42.42 0 0 1 0-.606l2.625-2.571a.444.444 0 0 1 .619 0m7.875 0a.444.444 0 0 0-.619 0 .42.42 0 0 0 0 .606l2.316 2.268-2.316 2.269a.423.423 0 0 0 0 .606.445.445 0 0 0 .619 0l2.625-2.572a.42.42 0 0 0 0-.606z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBody);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/body.2c90f8d0.svg";